import * as styles from './styles';
import FocusableIconButton from '@components/FocusableIconButton';
import { useMatchingFailContext } from '@context/MatchingFail';
import { GO_MAIN } from '../../../focuskey';

const ButtonContainer = () => {
  const { goMain } = useMatchingFailContext();

  return (
    <div css={styles.container}>
      <div css={styles.buttonContainer}>
        <FocusableIconButton onEnterPress={goMain} focusKey={GO_MAIN} iconType="arrow">
          홈으로
        </FocusableIconButton>
      </div>
    </div>
  );
};

export default ButtonContainer;
